// Generated by purs version 0.11.7
"use strict";
var TaggedObject = (function () {
    function TaggedObject(value0) {
        this.value0 = value0;
    };
    TaggedObject.create = function (value0) {
        return new TaggedObject(value0);
    };
    return TaggedObject;
})();
module.exports = {
    TaggedObject: TaggedObject
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Foreign.Generic.Types/index.js
// module id = 276
// module chunks = 0